import { useLocale } from '@tundr/i18n';
import { useModal } from '@tundr/modal';
import { useNavigationGuardStore } from '../store/navigation-guard.store';

export const useConfirmNavigationGuard = () => {
  const navigationGuardStore = useNavigationGuardStore();
  const { openConfirmModal } = useModal();
  const { t } = useLocale('common');

  const confirmNavigationGuard = () =>
    new Promise<boolean>((resolve) => {
      navigationGuardStore.setIsExitConfirmed(false);

      if (!navigationGuardStore.isBlocked) {
        resolve(true);
        return;
      }

      openConfirmModal({
        title: t('confirm_exit.title'),
        message: t('confirm_exit.description'),
        config: { blocking: true },
        labels: {
          confirm: t('actions.exit'),
          cancel: t('actions.cancel'),
        },
        events: {
          onConfirm: () => {
            navigationGuardStore.setIsBlocked(false);
            navigationGuardStore.setIsExitConfirmed(true);
            resolve(true);
          },
          onCancel: () => resolve(false),
        },
      });
    });

  return {
    confirmNavigationGuard,
  };
};
